/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_PlanInputs */

const en_settings_billing_plan = /** @type {(inputs: Settings_Billing_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const zh_settings_billing_plan = /** @type {(inputs: Settings_Billing_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套餐`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Settings_Billing_PlanInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_plan = /** @type {((inputs?: Settings_Billing_PlanInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_PlanInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_plan(inputs)
	return zh_settings_billing_plan(inputs)
});
export { settings_billing_plan as "settings.billing.plan" }